export default [
  {
    path: '/dashboard',
    name: 'dashboard',
    meta: {
      requiresAuth: true,
      pageTitle: 'Overview',
    },
    component: () => import('@/views/dashboard/Dashboard.vue'),
  },
]
